<template>
  <div v-if="tagList">
    <dara-header size="sm">{{ $t('trending-tags') }}</dara-header>
    <dara-invisible v-if="tagList.length">
      <dara-tag
        v-for="tag in tagList"
        :key="tag.id"
        :to="getTagLink(tag)"
        :label="tag.name"
        class="mr--md mb--md" />
    </dara-invisible>
    <dara-invisible v-else>
      <dara-p color="info">( {{ $t('empty-trending-tags') }} )</dara-p>
    </dara-invisible>
  </div>
</template>

<script>
import { fetchTags, getTagLink } from '@/modules/tag/tag.service';

export default {
  name: 'DaraHomeTrendingTags',
  data() {
    return {
      tagList: null,
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    getTagLink,
    fetch() {
      fetchTags()
        .then(data => {
          this.tagList = data.data;
        })
        .catch();
    },
  },
};
</script>
